import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid m-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-offset-3 mb-0" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-light" }, "Post a new link")
], -1)
const _hoisted_3 = { class: "p-0 col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3" }

import NavBar from "@/components/NavBar.vue";
import NewPostCard from "@/components/post/NewPostCard.vue";
import router from "../router";
import { useMutation } from "@vue/apollo-composable";
import gql from "graphql-tag";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const mutation = gql`
  mutation insertPostWithTags(
    $description: String!
    $url: String!
    $post_tag_insert_input: [post_tag_insert_input!]!
  ) {
    insert_post_one(
      object: {
        url: $url
        description: $description
        post_tags: { data: $post_tag_insert_input }
      }
    ) {
      add_post_to_rss
      save_title
      uuid
    }
  }
`;

const { mutate, onDone, loading } = useMutation(mutation);

const submit = ({ url, description, tags }: { url: string, description: string, tags: string[] }) => {
  let post_tag_insert_input: any[] = [];

  tags.forEach((tag: string) => {
    post_tag_insert_input.push({
      tag: {
        data: { name: tag.toLowerCase() },
        on_conflict: {
          constraint: "tag_name_key",
          update_columns: ["blank"],
        },
      },
    });
  });

  mutate({
    url,
    description: description ? description : "",
    post_tag_insert_input,
  });
};

onDone(({ data: { insert_post_one: { uuid } } }) => {
  router.push(`/post/${uuid}`);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(NavBar),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(NewPostCard, {
          onPostClick: _cache[0] || (_cache[0] = ($event: any) => (submit($event))),
          loading: _unref(loading)
        }, null, 8, ["loading"])
      ])
    ])
  ]))
}
}

})